export default __webpack_public_path__ + "static/media/marvel-logo.41df6f0e.png";